import { ROOT_CATEGORY_ID } from "./constants";
import { normalizeUserQuantity } from "./normalizeUserQuantity";


export function normalizeUserSnapshot(data) {

  const categoriesById = {};
  const quantitiesById = {};
  const categoryIds = [];

  const categories = Array.isArray(data)
    ? data
    : data?.categories || [];

  for (const category of categories) {
    const isRoot = category.id == null;

    const categoryId = isRoot
      ? ROOT_CATEGORY_ID
      : category.id;
    categoryIds.push(categoryId); // Store ID in order
    const categoryNode = {
      id: categoryId,
      nodeId: isRoot ? ROOT_CATEGORY_ID : `c${category.id}`,
      code: category.code || null,
      title: category.title || "",
      isActive: category?.is_active ?? true,
      type: "category",
      orderNumber: category.order_number ?? 9999,
      quantities: [],
    };
    
    for (const q of category.quantities || []) {

      const qNode = normalizeUserQuantity(q);

      quantitiesById[qNode.nodeId] = qNode;

      categoryNode.quantities.push(qNode);
    }

    categoriesById[categoryId] = categoryNode;
  }

  return {
    categoriesById,
    quantitiesById,
    categoryIds,
  };
}